import React, {  useEffect, useCallback} from 'react';  
import { useTranslation } from "react-i18next" 
import Box from '@mui/material/Box'; 
import Container from '@mui/material/Container'; 
import SwipeableDrawer from '@mui/material/SwipeableDrawer';  
import "css/generalSettings.css";   
import "css/customDialog.css";
import PropTypes from 'prop-types';
  
const SendEmailEdit = ({ openEditRow,setOpenEditRow,rowEdit}) => {
  const {t,i18n} = useTranslation(['listDataGeneralSettings']); 
 
  const keyPress = useCallback(
    (e) => {
      if (e.key === 'Escape' && openEditRow) {
        setOpenEditRow(false);  
      }
    },
    [
      setOpenEditRow,  
      openEditRow
    ]
  );

  const closeModalSentEmailEdit = () => {
    setOpenEditRow(false);   
  }; 

  const toggleDrawerEmail = (open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    if (event.type === 'keydown' ) {
      closeModalSentEmailEdit();
      return;
    }
  };
      
  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event && typeof event === 'object' && event.key) {
        keyPress(event);
      }
    };
    document.addEventListener('keydown', handleKeyPress);
    return () => {
      document.removeEventListener('keydown', handleKeyPress);
    };
  }, [keyPress]);

    const reportLines = (rowEdit?.reports ?? "")
    .split(/\r?\n/)
    .map(l => l.trim())
    .filter(Boolean);

  const isOkLine = (line) =>
    /PROCESADO CORRECTAMENTE|OK/i.test(line);

  const isKoLine = (line) =>
    /KO|INVÁLIDA|INVALIDA|ERROR|FAILED/i.test(line);

  const okCount = reportLines.filter(isOkLine).length;
  const koCount = reportLines.filter(isKoLine).length;

  const globalStatus =
    koCount === 0 ? "OK" :
    okCount === 0 ? "KO" :
    "PARTIAL";
 
  return (
    <div> 
      {openEditRow && 
        <div>
          <SwipeableDrawer
            anchor='right'
            open={true}
            onClose={toggleDrawerEmail(false)}
            onOpen={toggleDrawerEmail(true)}
          >
            <Container >
              <Box sx={{ bgcolor: '#ffffff',height:'100vh', width: '1100px' }}>
                <br/>
                {/* HEADER */}
                <div className="email-card-header">
                  <div className="email-header-content">
                    <div className="email-header-icon">
                      <i className="fas fa-solid fa-envelope text-warning"></i>
                    </div>

                    <div className="email-header-text">
                      <div className="email-header-title">
                        {t('Text_EMAIL_Email')}
                      </div>
                      <div className="email-header-number">
                        {rowEdit.emailto}
                      </div>
                    </div>
                    {/* 👉 ESTADO GLOBAL */}
                    <div className={`email-status-pill email-status-${globalStatus.toLowerCase()}`}>
                      {globalStatus === "OK" && "✔ ENVÍO CORRECTO"}
                      {globalStatus === "KO" && "✖ ENVÍO FALLIDO"}
                      {globalStatus === "PARTIAL" && "⚠ ENVÍO PARCIAL"}
                    </div>
                    <div className="email-card-actions"> 
                      <button type="button" className="email-cancel-btn" onClick={closeModalSentEmailEdit} >
                        {t('Button_Back')}
                      </button> 
                    </div>
                  </div>
                </div> 
                <br/> 
                <div className="email-card-form"> 
                  <div className="row p-4">
                    <label className="text-primary">{t("Text_SENDEMAIL_Subject")} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp;

                    <div
                      className="email-box email-box-primary"
                      style={{ width: i18n.language === "es" ? 957 : 962 }}
                      title={rowEdit.subjectEmail ?? ""}
                    >
                      {rowEdit.subjectEmail ?? ""}
                    </div>
                  </div>
                  <div className="row p-4">
                    <label className="text-primary">{t("Text_SENDEMAIL_Content")} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp;

                    <div
                      className="email-box email-box-neutral"
                      style={{ width: i18n.language === "es" ? 938 : 955 }}
                    >
                      <pre className="email-pre">
                        {rowEdit.contentEmail ?? ""}
                      </pre>
                    </div>
                  </div>  
                  <div className="row p-4">
                  <label className="text-danger">{t("Text_Reports")} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp;
                    <div
                      className="reports-box"
                      style={{ width: i18n.language === "es" ? 946 : 955 }}
                    >
                      <ul className="reports-list">
                        {reportLines.map((line, idx) => {
                          const statusClass = isOkLine(line)
                            ? "report-ok"
                            : isKoLine(line)
                              ? "report-ko"
                              : "report-neutral";
                          return (
                            <li key={idx} className={`reports-item ${statusClass}`}>
                              {line}
                            </li>
                          );
                        })}
                      </ul>
                    </div>
                  </div>
                </div> 
                
              </Box>
            </Container>
          </SwipeableDrawer>  
        </div>
      } 
    </div>
  )
}

SendEmailEdit.propTypes = {
  openEditRow: PropTypes.bool.isRequired,
  setOpenEditRow: PropTypes.func.isRequired 
};
  
export default SendEmailEdit;

